/*
 * @Descripttion: 国网物料调价页面
 * @Author: 曹博
 * @Date: 2023-10-24 09:10:50
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-09 13:28:52
 */
import styles from './materialPriceAdjustment.module.scss'
import TableAntd from '../../components/TableAntd'
import Search from '../../components/SearchFilter'
import {
  Col,
  ConfigProvider,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Space,
  Tooltip,
} from 'antd'
import Buttonbar from '../../components/ButtonBar'
import UseMaterialPriceAdjustmentHooks from './hooks'
import { GwProductItem } from '../../api/InventoryManagementApi'
import { QuestionCircleFilled } from '@ant-design/icons'
import { formatStr } from '../../tools/util'
import { adjustPriceRules } from '../../modules/goodsdetailmodules/maininfo'

// 调价类型
export const adjustTypeList = [
  {
    key: '1',
    name: '最低价',
  },
  {
    key: '2',
    name: '3/5%以内',
  },
  {
    key: '3',
    name: '自定义调价',
  },
] as const

const MaterialPriceAdjustment = () => {
  const {
    hookstate,
    form,
    handleSearchClick,
    onRefresh,
    handlePaginationChange,
    changePriceAdjustmentModalVis,
    cofirmPriceAdjustment,
    // onhandlDetail,
    onCopy,
  } = UseMaterialPriceAdjustmentHooks()
  const {
    dataSource,
    pages,
    loading,
    isPriceAdjustmentModalOpen,
    currentApplyProductMainInfo,
    isPriceAdjustConfirmBtnLoading,
    hasRules,
  } = hookstate

  // 表单布局
  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 },
  }

  // 表头
  const columns = [
    {
      key: 'code',
      title: '咸亨商品编码',
      dataIndex: 'code',
      // render: (text: string, record: GwProductItem) => (
      //   <span className={'primaryBtn'} onClick={() => onhandlDetail(record)}>
      //     {text}
      //   </span>
      // ),
    },
    {
      key: 'gwCode',
      title: '国网物料编码',
      dataIndex: 'gwCode',
    },
    {
      key: 'spuModel',
      title: '产品编码',
      dataIndex: 'spuModel',
    },
    {
      key: 'gwProductSerialNumber',
      title: '国网商品编码',
      dataIndex: 'gwProductSerialNumber',
      render: (text: string) => text || '-',
    },
    {
      key: 'name',
      title: '物料名称',
      dataIndex: 'name',
    },
    {
      key: 'highestChangePrice',
      title: '最高可改价',
      dataIndex: 'highestChangePrice',
    },
    {
      key: 'categoryName',
      title: '类目名称',
      dataIndex: 'categoryName',
    },
    {
      key: 'brandPrice',
      title: '品牌控价',
      dataIndex: 'brandPrice',
    },
    {
      key: 'regionalPrice',
      title: '专区价',
      dataIndex: 'regionalPrice',
    },
    {
      key: 'onShelfStatusToName',
      title: '专区上下架状态',
      dataIndex: 'onShelfStatusToName',
    },
    {
      key: 'soldCount',
      title: '销量',
      dataIndex: 'soldCount',
    },
    {
      key: 'minSalePrice',
      title: '最低价',
      dataIndex: 'minSalePrice',
    },
    {
      key: 'operate',
      title: '操作',
      dataIndex: 'operate',
      render: (text: string, record: GwProductItem) => (
        <div className={styles['operate']}>
          {/* 国网商品编码不存在时不可调价 */}
          {!record.gwProductSerialNumber ? (
            <span style={{ color: '#777' }}>无法调价</span>
          ) : (
            <>
              {/* 判断是否可调价 */}
              {record.adjustPrice ? (
                <a
                  onClick={() => changePriceAdjustmentModalVis(true, record)}
                  style={{ userSelect: 'none' }}
                >
                  {/* 判断是否是首次调价 */}
                  {record.lastCause ? '再次调价' : '调价'}
                </a>
              ) : (
                <span style={{ color: '#777' }}>调价中...</span>
              )}
              {record.lastCause ? (
                <Tooltip
                  placement="top"
                  title={record.causeOfRejection}
                  getPopupContainer={() => document.body}
                >
                  <span
                    style={{
                      display: 'inline-block',
                      marginLeft: '8px',
                      color: '#F5222D',
                      cursor: 'default',
                    }}
                  >
                    驳回
                  </span>
                </Tooltip>
              ) : (
                ''
              )}
            </>
          )}
          <span
            className={styles['link']}
            onClick={() => onCopy(record.mallLink)}
          >
            复制链接
          </span>
        </div>
      ),
    },
  ]

  // 空数据
  const emptyRender = () => {
    return (
      <div style={{ margin: '150px auto', color: 'black' }}>
        {loading === false &&
          (hasRules ? (
            <div>
              <p>暂无数据</p>
            </div>
          ) : (
            <div>
              <p>您好，您没有国网履约权限，不能查看本页面数据</p>
              <p style={{ color: 'black' }}>如有需要请联系咸亨工作人员</p>
            </div>
          ))}
      </div>
    )
  }

  // // 步骤条提示内容
  // const renderSubTitle = (val: ProgressItem) => (
  //   <Space>
  //     <span>
  //       <span
  //         style={{
  //           display: 'inline-block',
  //           marginLeft: '8px',
  //           fontSize: '12px',
  //           color: progressItemStatusList.find(
  //             (item) => item.state === val.status,
  //           )?.color,
  //         }}
  //       >
  //         {val.status === 'loading' && (
  //           <LoadingOutlined style={{ marginRight: 8 }} />
  //         )}
  //         {
  //           progressItemStatusList.find((item) => item.state === val.status)
  //             ?.des
  //         }
  //       </span>
  //     </span>
  //   </Space>
  // )

  // 金额提示
  const adjustPriceWarning = [
    '可点最高价=国网各家最低价*国网点单率',
    '调价金额<=可点最高价',
  ]

  const validateAdjustPrice = (_: any, value: number) => {
    if (value > Number(currentApplyProductMainInfo.highestChangePrice)) {
      return Promise.reject(new Error('调价金额不能超过可点最高价'))
    }
    return Promise.resolve()
  }
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'productCode',
          'gwCode',
          'spuModel',
          'gwProductSerialNumber',
          'proName',
          'categoryName',
        ]}
        onSearch={handleSearchClick}
        keyName="MATERIALPRICEADJUSTMENT"
        ScreenKey="MATERIALPRICEADJUSTMENT"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Buttonbar onRefresh={onRefresh}></Buttonbar>
        </Space>
      </Row>
      <ConfigProvider renderEmpty={emptyRender}>
        <TableAntd
          dataSource={dataSource.data}
          listColumn={columns}
          loading={loading}
          Y={340}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pageSize,
            onChange: handlePaginationChange,
          }}
          showSize
        />
      </ConfigProvider>

      {/* 修改库存弹框 */}
      <Modal
        title={'调价申请'}
        open={isPriceAdjustmentModalOpen}
        width={600}
        keyboard={false}
        maskClosable={false}
        onCancel={() => changePriceAdjustmentModalVis(false, {})}
        cancelButtonProps={{
          disabled: isPriceAdjustConfirmBtnLoading,
          onClick: () => changePriceAdjustmentModalVis(false, {}),
        }}
        okButtonProps={{
          type: 'primary',
          onClick: cofirmPriceAdjustment,
          loading: isPriceAdjustConfirmBtnLoading,
        }}
      >
        <div>咸亨商品编码：{currentApplyProductMainInfo.code}</div>
        <div>最高可改价：{currentApplyProductMainInfo.highestChangePrice}</div>

        <Form form={form} style={{ marginTop: '12px' }} labelAlign={'right'}>
          <Row>
            <Col span={24}>
              <Form.Item
                name="adjustPrice"
                label="调价金额"
                rules={[
                  {
                    required: true,
                    message: '请输入调价金额',
                  },
                  {
                    validator: validateAdjustPrice,
                  },
                  ...adjustPriceRules,
                ]}
                getValueFromEvent={(e) => {
                  return formatStr(e.target.value, 'NumberDecimal')
                }}
                {...formItemLayout}
              >
                <div style={{ display: 'flex' }}>
                  <InputNumber
                    min={0}
                    max={99999999}
                    precision={2}
                    style={{ width: '300px' }}
                    placeholder="请输入自定义调价金额"
                  />
                  <span>
                    <Tooltip
                      title={
                        <div
                          style={{
                            textIndent: '1em',
                          }}
                        >
                          {adjustPriceWarning.map((item, index) => (
                            <div key={index}>{item}</div>
                          ))}
                        </div>
                      }
                    >
                      <QuestionCircleFilled
                        style={{ color: '#AAAAAA', marginLeft: '4px' }}
                      />
                    </Tooltip>
                  </span>
                </div>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="备注" name="remark" {...formItemLayout}>
                <Input
                  placeholder="请输入备注"
                  style={{ width: '300px' }}
                  maxLength={200}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {/* {submitApplyFlag ? (
          <div style={{ marginLeft: '24px' }}>
            <div style={{ marginTop: '-4px', marginBottom: '12px' }}>
              价格计算中，可能需要1~2分钟时间从国网获取实时价格，请勿关闭页面……
            </div>
            <Steps direction="vertical" size="small" current={currentStep}>
              {progressList.map((item) => (
                <Step
                  key={item.title}
                  title={item.title}
                  subTitle={renderSubTitle(item)}
                />
              ))}
            </Steps>
          </div>
        ) : (
          <div>
            <div
              style={{
                margin: '-12px 0 12px 24px',
              }}
            >
              <Row>
                <Col span={12}>
                  物料编码：{currentApplyProductMainInfo.code}
                </Col>
                <Col span={12}>
                  品牌：{currentApplyProductMainInfo.brandName}
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  物料名称：{currentApplyProductMainInfo.name}
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  规格型号：{currentApplyProductMainInfo.manuCode}
                </Col>
              </Row>
            </div>
            <Form form={form} {...formItemLayout}>
              <Form.Item
                name="adjustPrice"
                label="调价金额"
                rules={[
                  {
                    required: true,
                    message: '请输入调价金额',
                  },
                  {
                    pattern: /^.{0,13}$/,
                    message: '最多输入13位数字',
                  },
                  ...priceRules,
                ]}
                getValueFromEvent={(e) => {
                  return formatStr(e.target.value, 'NumberDecimal')
                }}
              >
                <Input placeholder="请输入自定义调价金额" />
              </Form.Item>
              <Form.Item
                name="adjustType"
                label="调价类型"
                rules={[{ required: true, message: '请选择调价类型' }]}
              >
                <Radio.Group onChange={onAdjustPriceTypeChange}>
                  <Space direction="vertical">
                    {adjustTypeList.map((item) => (
                      <Radio key={item.key} value={item.key}>
                        {item.name}
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Form.Item>
              {isDefinition && (
                <>
                  <Form.Item
                    name="adjustPrice"
                    label="调价金额"
                    rules={[
                      {
                        required: true,
                        message: '请输入调价金额',
                      },
                      {
                        pattern: /^.{0,13}$/,
                        message: '最多输入13位数字',
                      },
                      ...priceRules,
                    ]}
                    getValueFromEvent={(e) => {
                      return formatStr(e.target.value, 'NumberDecimal')
                    }}
                  >
                    <Input placeholder="请输入自定义调价金额" />
                  </Form.Item>
                  <Form.Item name="remark" label="备注">
                    <Input placeholder="请输入" />
                  </Form.Item>
                </>
              )}
            </Form>
          </div>
        )} */}
      </Modal>
    </div>
  )
}
export default MaterialPriceAdjustment
/*
 * @Descripttion: 国网物料调价页面
 * @Author: 曹博
 * @Date: 2023-10-24 09:10:50
 * @LastEditors: 曹博
 * @LastEditTime: 2023-11-09 13:28:52
 */
import styles from './materialPriceAdjustment.module.scss'
import TableAntd from '../../components/TableAntd'
import Search from '../../components/SearchFilter'
import {
  Col,
  ConfigProvider,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Space,
  Tooltip,
} from 'antd'
import Buttonbar from '../../components/ButtonBar'
import UseMaterialPriceAdjustmentHooks from './hooks'
import { GwProductItem } from '../../api/InventoryManagementApi'
import { QuestionCircleFilled } from '@ant-design/icons'
import { formatStr } from '../../tools/util'
import { adjustPriceRules } from '../../modules/goodsdetailmodules/maininfo'

// 调价类型
export const adjustTypeList = [
  {
    key: '1',
    name: '最低价',
  },
  {
    key: '2',
    name: '3/5%以内',
  },
  {
    key: '3',
    name: '自定义调价',
  },
] as const

const MaterialPriceAdjustment = () => {
  const {
    hookstate,
    form,
    handleSearchClick,
    onRefresh,
    handlePaginationChange,
    changePriceAdjustmentModalVis,
    cofirmPriceAdjustment,
    // onhandlDetail,
    onCopy,
  } = UseMaterialPriceAdjustmentHooks()
  const {
    dataSource,
    pages,
    loading,
    isPriceAdjustmentModalOpen,
    currentApplyProductMainInfo,
    isPriceAdjustConfirmBtnLoading,
    hasRules,
  } = hookstate

  // 表单布局
  const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 14 },
  }

  // 表头
  const columns = [
    {
      key: 'code',
      title: '咸亨商品编码',
      dataIndex: 'code',
      // render: (text: string, record: GwProductItem) => (
      //   <span className={'primaryBtn'} onClick={() => onhandlDetail(record)}>
      //     {text}
      //   </span>
      // ),
    },
    {
      key: 'gwCode',
      title: '国网物料编码',
      dataIndex: 'gwCode',
    },
    {
      key: 'spuModel',
      title: '产品编码',
      dataIndex: 'spuModel',
    },
    {
      key: 'gwProductSerialNumber',
      title: '国网商品编码',
      dataIndex: 'gwProductSerialNumber',
      render: (text: string) => text || '-',
    },
    {
      key: 'name',
      title: '物料名称',
      dataIndex: 'name',
    },
    {
      key: 'highestChangePrice',
      title: '最高可改价',
      dataIndex: 'highestChangePrice',
    },
    {
      key: 'categoryName',
      title: '类目名称',
      dataIndex: 'categoryName',
    },
    {
      key: 'brandPrice',
      title: '品牌控价',
      dataIndex: 'brandPrice',
    },
    {
      key: 'regionalPrice',
      title: '专区价',
      dataIndex: 'regionalPrice',
    },
    {
      key: 'onShelfStatusToName',
      title: '专区上下架状态',
      dataIndex: 'onShelfStatusToName',
    },
    {
      key: 'soldCount',
      title: '销量',
      dataIndex: 'soldCount',
    },
    {
      key: 'minSalePrice',
      title: '最低价',
      dataIndex: 'minSalePrice',
    },
    {
      key: 'operate',
      title: '操作',
      dataIndex: 'operate',
      render: (text: string, record: GwProductItem) => (
        <div className={styles['operate']}>
          {/* 国网商品编码不存在时不可调价 */}
          {!record.gwProductSerialNumber ? (
            <span style={{ color: '#777' }}>无法调价</span>
          ) : (
            <>
              {/* 判断是否可调价 */}
              {record.adjustPrice ? (
                <a
                  onClick={() => changePriceAdjustmentModalVis(true, record)}
                  style={{ userSelect: 'none' }}
                >
                  {/* 判断是否是首次调价 */}
                  {record.lastCause ? '再次调价' : '调价'}
                </a>
              ) : (
                <span style={{ color: '#777' }}>调价中...</span>
              )}
              {record.lastCause ? (
                <Tooltip
                  placement="top"
                  title={record.causeOfRejection}
                  getPopupContainer={() => document.body}
                >
                  <span
                    style={{
                      display: 'inline-block',
                      marginLeft: '8px',
                      color: '#F5222D',
                      cursor: 'default',
                    }}
                  >
                    驳回
                  </span>
                </Tooltip>
              ) : (
                ''
              )}
            </>
          )}
          <span
            className={styles['link']}
            onClick={() => onCopy(record.mallLink)}
          >
            复制链接
          </span>
        </div>
      ),
    },
  ]

  // 空数据
  const emptyRender = () => {
    return (
      <div style={{ margin: '150px auto', color: 'black' }}>
        {loading === false &&
          (hasRules ? (
            <div>
              <p>暂无数据</p>
            </div>
          ) : (
            <div>
              <p>您好，您没有国网履约权限，不能查看本页面数据</p>
              <p style={{ color: 'black' }}>如有需要请联系咸亨工作人员</p>
            </div>
          ))}
      </div>
    )
  }

  // // 步骤条提示内容
  // const renderSubTitle = (val: ProgressItem) => (
  //   <Space>
  //     <span>
  //       <span
  //         style={{
  //           display: 'inline-block',
  //           marginLeft: '8px',
  //           fontSize: '12px',
  //           color: progressItemStatusList.find(
  //             (item) => item.state === val.status,
  //           )?.color,
  //         }}
  //       >
  //         {val.status === 'loading' && (
  //           <LoadingOutlined style={{ marginRight: 8 }} />
  //         )}
  //         {
  //           progressItemStatusList.find((item) => item.state === val.status)
  //             ?.des
  //         }
  //       </span>
  //     </span>
  //   </Space>
  // )

  // 金额提示
  const adjustPriceWarning = [
    '可点最高价=国网各家最低价*国网点单率',
    '调价金额<=可点最高价',
  ]

  const validateAdjustPrice = (_: any, value: number) => {
    if (value > Number(currentApplyProductMainInfo.highestChangePrice)) {
      return Promise.reject(new Error('调价金额不能超过可点最高价'))
    }
    return Promise.resolve()
  }
  return (
    <div className={styles['container']}>
      <Search
        fieldsData={[
          'productCode',
          'gwCode',
          'spuModel',
          'gwProductSerialNumber',
          'proName',
          'categoryName',
        ]}
        onSearch={handleSearchClick}
        keyName="MATERIALPRICEADJUSTMENT"
        ScreenKey="MATERIALPRICEADJUSTMENT"
      />
      <Row justify="space-between" className={styles['info-row']}>
        <Space>
          <Buttonbar onRefresh={onRefresh}></Buttonbar>
        </Space>
      </Row>
      <ConfigProvider renderEmpty={emptyRender}>
        <TableAntd
          dataSource={dataSource.data}
          listColumn={columns}
          loading={loading}
          Y={340}
          pagination={{
            total: dataSource.total,
            current: pages.pageNo,
            pagesize: pages.pageSize,
            onChange: handlePaginationChange,
          }}
          showSize
        />
      </ConfigProvider>

      {/* 修改库存弹框 */}
      <Modal
        title={'调价申请'}
        open={isPriceAdjustmentModalOpen}
        width={600}
        keyboard={false}
        maskClosable={false}
        onCancel={() => changePriceAdjustmentModalVis(false, {})}
        cancelButtonProps={{
          disabled: isPriceAdjustConfirmBtnLoading,
          onClick: () => changePriceAdjustmentModalVis(false, {}),
        }}
        okButtonProps={{
          type: 'primary',
          onClick: cofirmPriceAdjustment,
          loading: isPriceAdjustConfirmBtnLoading,
        }}
      >
        <div>咸亨商品编码：{currentApplyProductMainInfo.code}</div>
        <div>最高可改价：{currentApplyProductMainInfo.highestChangePrice}</div>

        <Form form={form} style={{ marginTop: '12px' }} labelAlign={'right'}>
          <Row>
            <Col span={24}>
              <Form.Item
                name="adjustPrice"
                label="调价金额"
                rules={[
                  {
                    required: true,
                    message: '请输入调价金额',
                  },
                  {
                    validator: validateAdjustPrice,
                  },
                  ...adjustPriceRules,
                ]}
                getValueFromEvent={(e) => {
                  return formatStr(e.target.value, 'NumberDecimal')
                }}
                {...formItemLayout}
              >
                <div style={{ display: 'flex' }}>
                  <InputNumber
                    min={0}
                    max={99999999}
                    precision={2}
                    style={{ width: '300px' }}
                    placeholder="请输入自定义调价金额"
                  />
                  <span>
                    <Tooltip
                      title={
                        <div
                          style={{
                            textIndent: '1em',
                          }}
                        >
                          {adjustPriceWarning.map((item, index) => (
                            <div key={index}>{item}</div>
                          ))}
                        </div>
                      }
                    >
                      <QuestionCircleFilled
                        style={{ color: '#AAAAAA', marginLeft: '4px' }}
                      />
                    </Tooltip>
                  </span>
                </div>
              </Form.Item>
            </Col>
          </Row>
          <Row>
            <Col span={24}>
              <Form.Item label="备注" name="remark" {...formItemLayout}>
                <Input
                  placeholder="请输入备注"
                  style={{ width: '300px' }}
                  maxLength={200}
                />
              </Form.Item>
            </Col>
          </Row>
        </Form>

        {/* {submitApplyFlag ? (
          <div style={{ marginLeft: '24px' }}>
            <div style={{ marginTop: '-4px', marginBottom: '12px' }}>
              价格计算中，可能需要1~2分钟时间从国网获取实时价格，请勿关闭页面……
            </div>
            <Steps direction="vertical" size="small" current={currentStep}>
              {progressList.map((item) => (
                <Step
                  key={item.title}
                  title={item.title}
                  subTitle={renderSubTitle(item)}
                />
              ))}
            </Steps>
          </div>
        ) : (
          <div>
            <div
              style={{
                margin: '-12px 0 12px 24px',
              }}
            >
              <Row>
                <Col span={12}>
                  物料编码：{currentApplyProductMainInfo.code}
                </Col>
                <Col span={12}>
                  品牌：{currentApplyProductMainInfo.brandName}
                </Col>
              </Row>
              <Row>
                <Col span={24}>
                  物料名称：{currentApplyProductMainInfo.name}
                </Col>
              </Row>
              <Row>
                <Col span={12}>
                  规格型号：{currentApplyProductMainInfo.manuCode}
                </Col>
              </Row>
            </div>
            <Form form={form} {...formItemLayout}>
              <Form.Item
                name="adjustPrice"
                label="调价金额"
                rules={[
                  {
                    required: true,
                    message: '请输入调价金额',
                  },
                  {
                    pattern: /^.{0,13}$/,
                    message: '最多输入13位数字',
                  },
                  ...priceRules,
                ]}
                getValueFromEvent={(e) => {
                  return formatStr(e.target.value, 'NumberDecimal')
                }}
              >
                <Input placeholder="请输入自定义调价金额" />
              </Form.Item>
              <Form.Item
                name="adjustType"
                label="调价类型"
                rules={[{ required: true, message: '请选择调价类型' }]}
              >
                <Radio.Group onChange={onAdjustPriceTypeChange}>
                  <Space direction="vertical">
                    {adjustTypeList.map((item) => (
                      <Radio key={item.key} value={item.key}>
                        {item.name}
                      </Radio>
                    ))}
                  </Space>
                </Radio.Group>
              </Form.Item>
              {isDefinition && (
                <>
                  <Form.Item
                    name="adjustPrice"
                    label="调价金额"
                    rules={[
                      {
                        required: true,
                        message: '请输入调价金额',
                      },
                      {
                        pattern: /^.{0,13}$/,
                        message: '最多输入13位数字',
                      },
                      ...priceRules,
                    ]}
                    getValueFromEvent={(e) => {
                      return formatStr(e.target.value, 'NumberDecimal')
                    }}
                  >
                    <Input placeholder="请输入自定义调价金额" />
                  </Form.Item>
                  <Form.Item name="remark" label="备注">
                    <Input placeholder="请输入" />
                  </Form.Item>
                </>
              )}
            </Form>
          </div>
        )} */}
      </Modal>
    </div>
  )
}
export default MaterialPriceAdjustment
